// action
import {
    SAVE_ARTICLE_LIKE,
    SAVE_ARTICLE_LIKE_FAIL,
    SAVE_ARTICLE_LIKE_SUCCESS,
    SAVE_ARTICLE_LIKE_RESET
} from '../action/saveArticleLikeAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "", 
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SAVE_ARTICLE_LIKE:
            return {
                ...state,
                apiState: "loading"
            }
        case SAVE_ARTICLE_LIKE_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case SAVE_ARTICLE_LIKE_SUCCESS:
            return {
                ...state,
                apiState: "success",
                message: action.response.data.message,
            }
        case SAVE_ARTICLE_LIKE_RESET:
            return initialState
        default:
            return state
    }
}